'use client'

import { Button } from '@/components/ui/button'
import { Experience } from '@/types'
import { useTranslation } from 'next-i18next'
import ExperienceBooking from '../app/experiences/experience-booking'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { isFreeExperience, isInIframe } from '@/helper/utils'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useAnalytics } from '@/hooks/use-analytics'
import { EventName } from '@/types/analytics'

export function ExperienceBookingSheet({
  experience,
  sellerId,
  bookable = true,
}: {
  experience: Experience
  sellerId: number
  bookable?: boolean
}) {
  const { t } = useTranslation('experience')
  const router = useRouter()
  const { trackExperience, timeEvent } = useAnalytics()

  const handleBookingInitiated = () => {
    // Start timing the purchase funnel
    timeEvent(EventName.OrderComplete)

    trackExperience(EventName.BookingInitiated, {
      experienceId: experience.id.toString(),
      experienceUuid: experience.uuid,
      experienceName: experience.name,
      category: experience.category?.name,
      isFree: isFreeExperience(experience),
      platform: 'widget',
    })
  }

  const widgetUuid = String(router.query.widgetUuid)
  if (isInIframe()) {
    return (
      <Button onClick={handleBookingInitiated}>
        <Link
          href={`/app/widgets/${widgetUuid}/experiences/${experience.uuid}/book`}
        >
          {t('book_now')}
        </Link>
      </Button>
    )
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button onClick={handleBookingInitiated}>{t('book_now')}</Button>
      </SheetTrigger>

      <SheetContent className="max-w-full w-full flex flex-col">
        <SheetHeader>
          <SheetTitle>{experience.name}</SheetTitle>
        </SheetHeader>

        <ExperienceBooking
          experience={experience}
          sellerId={sellerId}
          bookable={bookable}
          voucherOrder={undefined}
          widgetUuid={widgetUuid}
          redirectToCheckout={() => {
            router.push(`/app/checkout`)
          }}
        />
      </SheetContent>
    </Sheet>
  )
}
